<template>
    <v-snackbar
      v-model="snackbar"
      :color="color"
      class="common-snackbar"
      multi-line
      top
    >
      {{ text }}
    </v-snackbar>
</template>

<script>
    export default {
        name: 'snackbar',
        props: {
          text: { type: String },
          color: { type: String },
          snackbar: { type: Boolean }
        }
    }
</script>

<style scoped>
  .common-snackbar {
    z-index: 99999 !important;
  }
</style>
